
const jmkcate = [
  {
    id: 2,
    labelid: 573,
    name: "音乐",
    showname: "音 乐",
    eName: 'music',
    icon: 'icon-icon-music',
    path: '/program',
  },
  {
    id: 4,
    labelid: 574,
    name: "舞蹈",
    showname: "舞 蹈",
    eName: 'dance',
    icon: 'icon-icon-dance',
    path: '/program',
  },
  {
    id: 6,
    labelid: 575,
    name: "戏剧",
    showname: "戏 剧",
    eName: 'drama',
    icon: 'icon-icon-drama-lianpu',
    path: '/program',
  },
  {
    id: 8,
    labelid: 576,
    name: "曲艺",
    showname: "曲 艺",
    eName: 'chinese folk arts',
    icon: 'icon-icon-drum',
    path: '/program',
  },
  {
    id: 10,
    labelid: 577,
    name: "杂技",
    showname: "杂 技",
    eName: 'acrobatics',
    icon: 'icon-icon-lion-head',
    path: '/program',
  },
  {
    id: 342,
    labelid: 578,
    name: "其他",
    showname: "其 他",
    eName: 'other',
    icon: 'icon-icon-speaker-fill',
    path: '/program',
  },

]

const exhibitCate = [
  {
    id: 1,
    labelid: 712, // 710
    name: "美术",
    showname: "美 术",
    eName: 'the fine arts',
    icon: 'icon-meishu',
    path: '/exhibit',
    type: 'arts'
  },
  {
    id: 2,
    labelid: 713, // 711
    name: "书法",
    showname: "书 法",
    eName: 'calligraphy',
    icon: 'icon-shufa',
    path: '/exhibit',
    type: 'calligraphy'
  },
  {
    id: 3,
    labelid: 705, // 709
    name: "摄影",
    showname: "摄 影",
    eName: 'photography',
    icon: 'icon-sheying',
    path: '/exhibit',
    type: 'photo'
  }

]

const navlist = [
  {
    name: '首页',
    path: '/index',
    eName: "home",
  },
  {
    name: '节目库',
    path: '/program',
    eName: "program",
    icon: "icon-jmk",
    special: true,
    children: jmkcate
  },
  {
    name: '展品库',
    path: '/exhibit',
    eName: "exhibit",
    icon: "icon-zpk",
    special: true,
    // flag: "New"
  },
  {
    name: '文学库',
    path: '/literature',
    eName: "literature",
    icon: "icon-wxk",
    special: true,
    // flag: "New"
  },
  {
    name: '活动库',
    path: '/activity',
    eName: "activity",
    include: "/thematic"
  },
  {
    name: '人才库',
    path: '/artist',
    eName: "artist",
  },
  // {
  //   name:'专题库',
  //   path:'/thematic',
  //   eName:"thematic",
  // },

  {
    name: '获奖库',
    path: '/award',
    eName: "award",
  },
  {
    name: '海报库',
    path: '/poster',
    eName: "poster",
    // flag: "New"
  },
  {
    name: '新闻中心',
    path: '/news',
    eName: "news",
  }
]

const letters = ["全部", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", '#']

const literatureCate = [
  {
    id: 1,
    labelid: 725,
    name: "小说",
    showname: "小 说",
    eName: 'novel',
    icon: 'icon-shuben',
    path: '/literature',
  },
  {
    id: 2,
    labelid: 724,
    name: "散文",
    showname: "散 文",
    eName: 'prose',
    icon: 'icon-sanwen',
    path: '/literature',
  },
  {
    id: 3,
    labelid: 723,
    name: "剧本",
    showname: "剧 本",
    eName: 'script',
    icon: 'icon-juben',
    path: '/literature',
  },
  {
    id: 4,
    labelid: 722,
    name: "诗歌",
    showname: "诗 歌",
    eName: 'poetry',
    icon: 'icon-shici',
    path: '/literature',
  },
  {
    id: 5,
    labelid: 721,
    name: "曲谱",
    showname: "曲 谱",
    eName: 'Music score',
    icon: 'icon-qupu',
    path: '/literature',
  },
]


export default {
  jmkcate,
  exhibitCate,
  navlist,
  letters,
  literatureCate
}